module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_04_770_280_vi-f8d63072bf25f50d36248d344cc2d39d.jpg";